"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAcronym = getAcronym;

/**
 * Get first character.
 */
function getFirstCharacter(value) {
  var codePoint = value.codePointAt(0);

  if (codePoint === undefined) {
    return '';
  }

  return String.fromCodePoint(codePoint);
}
/**
 * Export `getAcronym`.
 */


function getAcronym(name) {
  if (!name) {
    return;
  }

  return name.toUpperCase().split(' ').map(getFirstCharacter).join('').substring(0, 2);
}